import { render, staticRenderFns } from "./jS.vue?vue&type=template&id=5b7d7b2e&"
import script from "./jS.vue?vue&type=script&lang=js&"
export * from "./jS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports